import React from 'react';
import { useState, useEffect } from 'react';
import Exclamation from '../../../../assets/icons/Exclamation';
import {
  Container,
  Header,
  Footer,
  Label,
  Reminder,
  ReText,
  Empty,
  DivIcon,
} from './styles';
import Input from '../../../../components/general/Input';
import Button from '../../../../components/general/Button';
import Close from '../../../../assets/icons/Close';
import Modal from '../../../../components/general/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { getAllFlowsTitleNames } from '../../../../state/flows/selectors';
import {
  handleAddProject,
  handleEditModelFlow,
} from '../../../../state/flows/actions';
import { useHistory } from 'react-router-dom';
import { toastAlert } from '../../../../components/Toastify';
import { usePromiseTracker, trackPromise } from 'react-promise-tracker';
import ReactLoading from 'react-loading';


const Save = ({
  current,
  title = '',
  isOpen,
  onClose,
  selector = '#root',
  className = 'nodrag',
  state,
  elements,
}) => {
  const [projectTitle, setProjectTitle] = useState(title);

  //Hooks
  const dispatch = useDispatch();
  const history = useHistory();
  const allflowsTitles = useSelector((state) => getAllFlowsTitleNames(state));
  const user = useSelector((state) => state.auth.user);

  const { promiseInProgress } = usePromiseTracker({ area: 'edit-flow' });


  //Toast Alert

  const label =
    current.type === 'main' ? 'Nome do projeto' : 'Nome do fluxo modelo';

  useEffect(() => {
    setProjectTitle(title);
  }, [title]);

  //Create Project
  const handleSaveModelFlow = () => {
    const newFlow = {
      title: projectTitle,
      type: 'main',
      tenantId: !user.tenantId ? user?._id : user.tenantId,
    };
    trackPromise(dispatch(
      handleAddProject({
        flow: newFlow,
        elements,
      })
    )
      .then((res) => {
        const title = res.payload.flow.title;
        toastAlert({
          msg: `Projeto  '${title}'  CRIADO com Sucesso!`,
        });
        history.push('/modelflows');
      })
      .catch((err) => {
        console.error(err);
        toastAlert({
          msg: `Ocorreu um ERRO ao CRIAR o projeto: '${err}'`,
          isError: true,
        });
      }), 'edit-flow')
  };
  //Edit Flow
  const handleEditFlow = () => {
    trackPromise(
      dispatch(
        handleEditModelFlow({
          elements: elements,
          title: projectTitle,
          flowId: current._id,
        })
      )
        .then((res) => {
          const title = res.payload.flow.title;
          toastAlert({
            msg: `Fluxo  '${title}'  EDITADO com Sucesso!`,
          });
          onClose();
        })
        .catch((err) => {
          console.error(err.message);
          toastAlert({
            msg: `Ocorreu um ERRO ao EDITAR o fluxo: '${current.title}'`,
            isError: true,
          });
        })

      , 'edit-flow')

  };

  function VersionException(errorMsg) {
    toastAlert({ msg: `${errorMsg}`, isError: true });
    this.message = `Error Exception: ${errorMsg}`;
  }

  //Verifica a existência de fluxo de mesmo nome
  const handleTitleValidation = () => {
    try {
      const findNameVersion = allflowsTitles
        .filter((item) => item.title !== current.title)
        .find((item) => item.title === projectTitle);

      if (findNameVersion) {
        throw new VersionException(
          `Versão "${projectTitle}" já foi cadastrada`
        );
      } else {
        handleEditFlow();
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>

        <Label>
          {state === 'edition'
            ? 'Editando o Fluxo Modelo'
            : 'Salvando o Fluxo Modelo'}
        </Label>
        <Reminder>
          <Exclamation style={{ height: '1.3125rem', width: '1.3125rem' }} />
          <ReText>
            Lembrete: Você está salvando o fluxo como: "{title}"
          </ReText>
        </Reminder>
        <Empty />

        {!promiseInProgress ? (
          <>
            <Input
              style={{ width: '23.75rem' }}
              value={projectTitle}
              setValue={(e) => {
                setProjectTitle(e);
              }}
              label={label}
              placeholder="Ex. Review 2.0"
              type="text"
            />

            <Footer>
              <Button
                outline
                content="Cancelar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onClose}
              />
              <Button
                disabled={projectTitle?.length === 0}
                content="Salvar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={() => {
                  if (state === 'edition') {
                    handleTitleValidation();
                  } else {
                    handleSaveModelFlow();
                  }
                }}
              />
            </Footer>
          </>
        ) : (
          <div
            style={{
              margin: '0 auto',
              padding: '2rem',

            }}
          >
            <ReactLoading type="bars" color="#118052" />
          </div>

        )}

        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default Save;
